var utils = require('../../utils')
import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'evaluate-question-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
    this.$store.dispatch('USERTYPE_ALL_GET', {})
  },
  data () {
    return {
      questions: [],
      searchTitle: '',
      searchUserType: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    userTypes () {
      return this.$store.getters.usertypesAll
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async search (addSearch) {
      let data = {
        search_title: this.searchTitle,
        search_target_user_type: this.searchUserType
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_EVALUATE_QUESTION_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      if (addSearch) {
        this.questions = this.questions.concat(res.questions.data)
      } else {
        this.questions = res.questions.data
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    goEvaluateQuestionNew: function () {
      this.$router.push({ path: '/evaluate_question/new' })
    },
    goEvaluateQuestionEdit: function (questionId) {
      this.$router.push({ path: '/evaluate_question/' + questionId + '/edit' })
    },
    goEvaluateQuestionDetail: function (questionId) {
      this.$router.push({ path: '/evaluate_question/' + questionId })
    },
    evaluateQuestionDelete: function (questionId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('EVALUATE_QUESTION_DELETE', {
          data: {
            id: questionId
          }
        })
        .then(res => {
          this.search(false)
        })
        .catch(err => console.log(err))
      }
    },
    isBeforeNotificationStartDate (notificationStartDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')
      return !DayJs(notificationStartDate).isAfter(today)
    },
    isReleaseStatus (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return '未公開'
      }
      if (DayJs(endDate).isBefore(today)) {
        return '公開完了'
      }
      return '公開中'
    },
    getColor: function (notificationStartDate, endDate) {
      let today = DayJs(new Date()).format('YYYY-MM-DD')

      if (DayJs(today).isBefore(notificationStartDate)) {
        return 'color-blue'
      }
      if (DayJs(endDate).isBefore(today)) {
        return 'color-gray'
      }
      return 'color-orange'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-list.js